export class RiskLevel {
    id: number;
    level: number;
    name: string;
    hexColor: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/risk-level.ts